module.exports = __webpack_public_path__ + "static/img/share.490fd95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/illus/share.png
// module id = 179
// module chunks = 9